export const START_EARNING_HEADING = `Join Us & Maximise Your Earning Potential! `
export const START_EARNING_SUBHEADING = `Ready to build new revenue streams and embark on a growth journey with PW Ambassador? 
Join us today and discover what it means to be part of a community that's dedicated to your success.`
export const START_EARNING_BUTTON_TEXT = `Get Started`
export const FAQ_HEADING = `Frequently Asked Questions`
export const WHY_SHOULD_I_ENROLL_AMBASSDOOR_HEADING = ` Why Should I enroll in PW Ambassador Program?`
export const AMBASSDOR_HEADING = `Words from Our Ambassadors`
export const GET_STARTED = `Get Started`
export const MAXIMIZE_SUBHEADING = `Your go-to platform for innovative marketing solutions. Whether you're a student, affiliate, or influencer, unlock a suite of tools to streamline your efforts, expand your reach, and achieve unparalleled growth.`
export const MAXIMIZE_HEADING = `Maximize Your Growth with`
export const PW_AMBASSDOR = `PW Ambassador`
export const CONTACT_US_BUTTON = `Write to Us`
export const CONTACT_US_SUBHEADING = `Have doubts? Our support team will be happy to assist you!`
export const CONTACT_US_HEADING = `Send Us a Mail`
export const VIDEO_HEADING = `How does the Program works?`
export const RESOURCE_DETAIL = `How PW Ambassador Works?`
export const RESOURCE_CENTER = `Resource Center`
export const AFFILIATE_PROFILE_DESCRIPTION = 'Enter the URL for your Portfolio'
export const CODE_COPIED = 'Code copied to clipboard!'
export const COUPON_HEADLING = 'Way to go!'
export const COUPON_INFO = 'This coupon code is now yours. Congratulations!'
export const Valid_Till = 'Valid Till'
export const REVEAL_CODE = 'to reveal your unique coupon'
export const GENERATE_CODE = 'Let’s get you started with earning'
export const COUPON_GENRATED = 'Coupon genrated successFully'
export const UNABLE_TO_GENRATED = 'Unable to generate coupon'
export const YET_TO_APPROVED = 'Your application  is yet to Approved!'
export const APPLICATION_INCOMPLETE = 'Your application is incomplete.'
export const APPLICATION_COMPLETED = 'Your application is complete'
export const APPLICATION_APPROVED = 'Your application is approved!'
export const UPDATE_YOUR_PAYMENT_DETAILS =
  'Please update your payment details to complete your application.'
export const STATISTICS_ALERT_MESSAGE = ` Your earnings are calculated based on your first 10 sales`
export const EFFECTIVE_FROM = `(effective from 1 June 2024).`
export const GRAPH_ERROR_MESSAGE = `Please select a date range less than 365 days`
export const APPLICATION_RECEIVED = `We've received your application, and it's currently under review`
export const APPLICATION_NOT_VERIFIED = `Until you update your payment details, your application won't be verified.`
export const APPLICATION_IS_NOT_VERIFIED = `Until your application is approved, you won't be able to generate a coupon`
export const APPLICATION_IS_UNDERREVIEW = `Until your application is approved, you won't be able to generate a coupon`

// Button types
export const STATUS_COMPLETED = ' Completed'
export const GENERATE = 'Generate Now'
export const UPDATE = 'Update Now'
export const TERMS_CONDITIONS = ` Terms & Conditions`
export const COPY = 'Copy'

// page headings
export const PAGE_HEADING_DASHBOARD = 'Dashboard'
export const PAGE_HEADING_COUPON = 'Coupon Generator'

// subHeadings
export const SUB_HEADING_COUPON = 'Generate Coupon'
export const SUB_HEADING_LEVELS = 'Levels'
export const SUB_STATISTICS = 'Statistics'
export const SUB_GENERATE = 'Generate'
export const TABLE_COMMISSION =
  '  Affiliate Commission and Student Discount Matrix'

// Generate Instructions
export const YOUR_COUPON = 'Earn through Coupon Code'
export const INFO_COUPON = `Looks like you haven’t generated your coupon yet. Click below to generate.`
export const COUPON_READY = 'Share your code to earn commission on every batch purchase!'

// profile Status (payment)
export const PENDING_PAYMENT = 'Please update your payment details'
export const UPDATED_PAYMENT =
  'Your payment details have successfully been updated.'
export const ADD_BANK_DETAILS = 'Add your bank account to receive payments.'
export const BANK_DETAILS_RECEIVE =
  'You will receive payments in your submitted bank account'

// profile Status (coupon)
export const PENDING_COUPON = 'Please generate your coupon.'
export const GENERATE_YOUR_COUPON =
  'You can start a promotion only after generating a coupon.'
  ; ('You will receive your monthly payments in your submitted bank account')

// Deactivation
export const DEACTIVATION_HEADING = `Your access needs to be refreshed`
export const DEACTIVATION_DISCRIPTION = `To continue earning, please re-activate your selling tools.`
export const DEACTIVATION_BTN = `Reactivate Now`

// Rejection & revoke
export const SUPPORT_ID = ` support.ambassador@pw.live`
export const WRITE_US = 'Write to Us'
export const APPLY_AGAIN = 'Apply Again'
export const REJECTED_HEADINGS = `We’re sorry, but your application could not be approved.`
export const REJECTED_DISCRIPTION = ` Please Contact Us`
export const REVOKE_HEADINGS = 'Oops! Your Access has been Revoked'
export const REVOKE_DISCRIPTION = `We are sorry, but you are currently restricted from accessing your dashboard.\n If you need further assistance, please contact our support team.`

export const ERROR_TITLE = 'Data has been submited successfully'
export const ALERT_TITLE = 'Please fill correct details'
// type for event
export const TYPE_AFFILIATE = 'AFFILIATE'
export const EMAIL_VERIFIED = 'Email verified successfully'
export const INCORRECT_OTP = 'OTP is incorrect.'
export const SERVER_ERROR = 'Server Error'
export const REGISTERED = 'Registered successfully'
export const APPLICATION_CREATION = 'Application Creation Failed'
export const BACK_BTN_LISTENER = 'popstate'
export const COLLEGE = 'College'
export const CLICK = 'click'
export const UL_BTN = 'ul'
export const LI_BTN = 'li'
export const INPUT_BTN = 'Input'
export const TEXT = 'text'

export const REMOVE_REASON_DATA = 'removeReason'
export const GENERATED_COUPON = 'generatedCoupon'
export const CURRENT_STATUS = 'currentStatus'
export const COUPON_DATA = 'couponData'
export const MY_PROFILE_DATA = 'MY_PROFILE_DATA'
export const CATEGORY = 'Category'
export const DISCOUNT = 'Student Discount'
export const NEW_STUDENT = 'Commission(New Student)'
export const REPEAT_STUDENT = 'Commission(Repeat Student)'
export const SALES_QUOTA = 'Sales Quota'
export const TOP = 'top'
export const INVALID_RANGE = 'Invalid Date Range '
export const INFO_NEW_STUDENT = `‘New Student’ refers to a registered student who has purchased up to one course of a selected exam category.`

export const INFO_OLD_STUDENT = `‘Repeat Student’ refers to a registered student who has purchased more than one course of a selected exam category.`

export const INFO_SALE_QUOTA = `‘Sales Quota’ refers to the maximum no. of sales per day that will be eligible for commission calculation & channel partner payout.`

export const REVENUE_TILES =
  'The cumulative count of all sales converted using your coupon.'
export const SALES_TILES =
  'The total sales revenue generated through your coupon to date.'
export const PAYOUTS_TILES =
  "The total commission you've earned from sales through your coupon."

export const PDF_LINK = 'PDF_LINK'
export const CERTIFICATE_URI = 'certificateUri'
export const INFO_STATEMENT =
  ' By clicking continue, you agree to PW Ambassador'

export const SMALL_CASE_TERMS_CONDITIONS = ` terms & conditions`
export const ERROR_MSG_FOR_NAME = 'Please enter valid name.'
export const ERROR_MSG_FOR_PHONE = 'Please enter valid phone number.'
export const ERROR_MSG_FOR_OTP = 'Fetching otp failed | Please try again'
export const ERROR_MSG_USER_EXIST = 'User does not exist'
export const TRY_AGAIN = 'Something went wrong | Please try again'
export const FULL_NAME = 'Full Name'

export const INPUT_EMAIL_ERROR = 'please enter valid email Id.'
export const INPUT_EMAIL_OTP_ERROR = 'please enter valid OTP.'

export const INPUT_EMAIL_PLACEHOLDER = 'eg: johndoe@gmail.com'
export const VERIFY_EMAIL = ' Email Verification'
export const ENTER_EMAIL = `Please enter your email address`
export const ENTER_DIGIT = ' Enter the 6-digit code sent to'

export const APPROVED_PROFILE_MSG =
  'Start earning by sharing personalised offers and assisting students with their purchases.'
export const UPDATED_PROFILE_MSG = `Your application is complete. Once approved, you will be able to generate a coupon.`
export const NEW_PROFILE_MSG = `Complete your application to start earning exclusive rewards`

export const APPROVED_PROFILE_TITLE = 'Congratulations! You’ve become'
export const UPDATED_PROFILE_TITLE = 'Almost there,'
export const NEW_PROFILE_TILE = 'One Step Closer to'

export const CERTIFICATE_READY_TITLE =
  'Congratulations! You are an official PW Affiliate Ambassador!'
export const CERTIFICATE_READY_MSG =
  'Download your official certificate to showcase your partnership with PW and celebrate your achievement'

export const FOR_NON_PDF =
  'File should be in PNG, JPG or JPEG format (upto 2MB)'
export const FOR_PDF =
  'File should be in PDF format. Max file size allowed is 2MB'
export const USER_NAME = 'fullName'

export const CAP_ID = 'totalPayoutCap'
export const TIP_COMMISSIOM_CAP =
  'This is the maximum payout you can receive every month and is subject to change in case of refunds or policy changes'
export const PAYOUT_CAP_INFO =
  'You have reached the maximum monthly payout cap for this month (subject to change in case of refunds or policy changes)'
export const CAP_INFO_ID = 'payOutCaping'

export const SHOW_COMMISSION = 'showCommission'
export const NOTIFICATION_STATUS = 'NotificationStatus'
export const Location = 'location'
export const locationEnabled = 'locationEnabled'
export const locationBlocked = 'locationBlocked'
export const SAATHI_EMPLOY = 'Employer/Organisation Name'
export const SAATHI_PROOF_EMPLOY = 'Proof of Employment'
export const PDF_INFO_MSG =
  'Upload your business card, pamphlet or any other supporting document'
export const FIRST_VIEW_SAATHI = `You are one step away from becoming a`
export const SAATHI_NAME = 'PW Saathi'
export const LEADS = 'Leads'

export const ACCEPTED_LEADS_TILE =
  'Leads that passed validation checks at the time of upload'
export const CONVERTED_LEADS_TILE =
  'Leads that converted and triggered attribution'
export const PROGRESS_LEADS_TILE =
  'Unconverted leads still eligible for conversion'
export const DEMO_FILE_LINK = `https://docs.google.com/spreadsheets/d/13i9X_nBzcTiEUM5V2JpLXPm2z87WGnp6GZDteDlIzMw/edit?gid=1219699337#gid=1219699337`

export const SAATHI_INFO_PARA = `Complete your application to start uploading leads.`
export const PAYMENT_SUCCESS_PARA = `Your application is complete. Once approved, you will be able to upload leads.`
export const FILE_MSG = 'File is uploaded successfully.'

export const SAATHI_REVENUSE_DATA = `Shows the totel earnings generated from all the programs.`
export const SAATHI_SALES_DATA = `Tracks the number of successful conversions generated throught the coupon codes.`
export const SAATHI_PAYOUT_DATA = `Shows the totel earnings generated from all the programs that are to be paid to the PW.`

export const FSM_MOBILE_NO = 'Invalid Parent Id'
export const FSM_MOBILE_NO_ALERT = 'FSE mobile number is invalid.'
export const FULL_NAME_SUGGESTION = 'Enter your full name as per bank passbook or cheque.'
export const PAYMENT_SUCCESS_MSG = 'Your application has been submitted successfully'
export const PAYMENT_DETAILS_RE_SUBMITED = 'Details Submitted.'

//CSC
export const CSS_LOGIN = 'Login with Digital Seva'
export const SPECIAL_LINK = 'Special link sent successfully!'
export const SIGN_UP_ORDER_TYPE = 5
export const TIP_COMMISSIOM_CAP_ASSITED_SALES =
  'This is the maximum payout for assisted sales you can receive every month and is subject to change in case of refunds or policy changes.'
export const TIP_COMMISSIOM_CAP_PERSONAL =
  'This is the maximum payout for personalised coupon you can receive every month and is subject to change in case of refunds or policy changes'
export const TOTAL_SIGN_UP = 'The total count of all successful sign-ups through your link.'
export const SIGN_UP_EARNING = `You earn your sign-up incentive when the student purchases a batch.`


export const ASSITED_SALES_REVENUE = `The total sales revenue generated through assisted sales to date.`
export const ASSITED_SALES_SALE = `The total count of all sales converted through  assisted sale.`
export const ASSITED_SALES_PAYOUT = `The total commission you've earned from  assisted sale.`


export const PERSONAL_REVENUE = `The total sales revenue generated through your personalised coupon to date.`
export const PERSONAL_SALES = `The total count of all sales converted using your personalised coupon.`
export const PERSONAL_PAYOUT = `The total commission you've earned from sales through your personalised coupon.`
export const CTA_NAME = 'Share Offer'

export const REFERRAL_MSG = 'Referral code should be a valid mobile number.'
export const ERROR_REFERRAL_MSG = 'Please enter valid referral code.'